import { render, staticRenderFns } from "./delivery.vue?vue&type=template&id=4d5ca02d&"
import script from "./delivery.vue?vue&type=script&lang=js&"
export * from "./delivery.vue?vue&type=script&lang=js&"
import style0 from "./delivery.vue?vue&type=style&index=0&id=4d5ca02d&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\code\\gongfeng\\CVSCRM_CODE\\scrm_manage_front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4d5ca02d')) {
      api.createRecord('4d5ca02d', component.options)
    } else {
      api.reload('4d5ca02d', component.options)
    }
    module.hot.accept("./delivery.vue?vue&type=template&id=4d5ca02d&", function () {
      api.rerender('4d5ca02d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/web/publicizeMaterialManagement/delivery.vue"
export default component.exports